import { SWITCH_CONNECTION_STATUS, SWITCH_LANGUAGE, TOGGLE_COLLAPSED_NAV, WINDOW_WIDTH } from '../constants/ActionTypes'

export function toggleCollapsedNav (isNavCollapsed) {
  return {type: TOGGLE_COLLAPSED_NAV, isNavCollapsed}
}

export function updateWindowWidth (width) {
  return {type: WINDOW_WIDTH, width}
}

export function switchLanguage (locale) {
  return {
    type: SWITCH_LANGUAGE,
    payload: locale
  }
}

export function switchConnectionStatus (status) {
  return {
    type: SWITCH_CONNECTION_STATUS,
    payload: {
      status
    }
  }
}



// WEBPACK FOOTER //
// ./actions/Setting.js